uniform vec3 uColorA;
uniform vec3 uColorB;
uniform float uColorMix;

void main()
{
    float distanceToCenter = distance(gl_PointCoord, vec2(0.5));
    float strength = 0.05 / distanceToCenter - 0.1;

    // Mix colors based on time
    vec3 color = mix(uColorA, uColorB, uColorMix);
    
    gl_FragColor = vec4(color, strength);
} 